import { StoredEvent } from '../event-store/stored-event.js';
import { HostPushSuccessResult } from './runtime-result.js';
import { TransactionOperation } from '../storage/transaction-operation.js';
import { assert } from '../typing/assert.js';
import { getStateData } from './get-state-data-keys.js';
import { getOrFail } from '../utils/get-or-fail.js';
import { OutputDeclarations } from '../stream/output-declarations.js';
import { fallbackAuth } from '../event-store/fallback-auth.js';

export function hostResultBuilder(
  outputs: OutputDeclarations,
  evt: StoredEvent,
) {
  const result: HostPushSuccessResult = {
    success: true,
    operation: [],
    outputs: [],
    auth: fallbackAuth(evt.auth),
    event: evt.event,
    eventId: evt.id,
  };

  return {
    addOperation(operation: TransactionOperation) {
      result.operation.push(operation);
    },
    addOutput<K extends string>(type: K, data: any) {
      const outputType = getOrFail(outputs, type);
      assert(data, outputType.type);
      result.outputs.push({
        id: `${evt.id}-${result.outputs.length + 1}`,
        type,
        sourceEventId: evt.id,
        data: getStateData(outputType.type, data),
      });
    },
    get() {
      return result;
    },
  };
}
